package app.smartcoding.realrate.domain.model

sealed interface ErrorType {
    data object PaymentLessThanLoan : ErrorType
    data object CalculationOverflow : ErrorType
    data object DivisionByZero : ErrorType
    data object NegativeResult : ErrorType
    data object RateTooHigh : ErrorType
    data object CalculationError : ErrorType
}